// React
import React from 'react';
import PropTypes from 'prop-types';

import {
  DropdownMultiselect,
  DropdownFilter
} from '@cybs-ui/components/lib/advanced-dropdown';

import CHDDBase from './BaseDropdown';

class FilterDropdown extends React.Component {
  displayName = 'FilterDropdown';

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      filters: []
    };
  }

  render() {
    const {
      options,
      labelKey,
      onCellChange,
      defaultId,
      variant,
      focusRef,
      cell,
      rowIdx,
      colIdx
    } = this.props;
    const { active, filters } = this.state;

    const baseProps = {
      items: options,
      labelKey,
      defaultId,
      onChange: newFilters => {
        this.setState(
          {
            active: Array.isArray(newFilters)
              ? newFilters && newFilters.length > 0
              : newFilters.id !== 'all',
            filters: Array.isArray(newFilters) ? newFilters : [newFilters]
          },
          () => {
            onCellChange(newFilters, cell, rowIdx, colIdx);
          }
        );
      }
    };

    switch (variant) {
      case 'base':
        return (
          <CHDDBase
            focusRef={focusRef}
            active={active}
            filters={filters}
            labelKey={labelKey}
            type={variant}
            {...baseProps}
          />
        );
      case 'filter':
        return (
          <DropdownFilter
            filterLabel="Filter items"
            onFilter={(item, inputValue) =>
              !inputValue ||
              item[labelKey].toLowerCase().includes(inputValue.toLowerCase())
            }
          >
            {filterProps => {
              const newProps = { ...baseProps, ...filterProps };
              return (
                <CHDDBase
                  focusRef={focusRef}
                  active={active}
                  filters={filters}
                  labelKey={labelKey}
                  type={variant}
                  {...newProps}
                />
              );
            }}
          </DropdownFilter>
        );
      case 'multiselect':
        return (
          <DropdownMultiselect>
            {multiProps => (
              <DropdownFilter
                filterLabel="Filter items"
                onFilter={(item, inputValue) =>
                  !inputValue ||
                  item[labelKey]
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                }
              >
                {filterProps => {
                  const newProps = {
                    ...baseProps,
                    ...filterProps,
                    ...multiProps
                  };
                  return (
                    <CHDDBase
                      focusRef={focusRef}
                      active={active}
                      filters={filters}
                      labelKey={labelKey}
                      type={variant}
                      {...newProps}
                    />
                  );
                }}
              </DropdownFilter>
            )}
          </DropdownMultiselect>
        );
      default:
        return <div />;
    }
  }
}

FilterDropdown.propTypes = {
  /**
   * Default id used for active styling
   */
  defaultId: PropTypes.string,
  /**
   * Accessbility ref
   */
  focusRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  /**
   * Key in option object for displaying label
   */
  labelKey: PropTypes.string,
  /**
   * Callback for updating selection
   */
  onCellChange: PropTypes.func.isRequired,
  /**
   * Option array with possible dropdown values
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired
    })
  ),
  /**
   * One of three types of dropdowns e.g. filter, base, multiselect
   */
  variant: PropTypes.oneOf(['filter', 'multiselect', 'base']).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cell: PropTypes.object.isRequired,
  rowIdx: PropTypes.number.isRequired,
  colIdx: PropTypes.number.isRequired
};

FilterDropdown.defaultProps = {
  defaultId: '',
  focusRef: null,
  labelKey: '',
  options: []
};

export default FilterDropdown;
